// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__12z_L","signatureButtonsRight":"ModalSign_signatureButtonsRight__1CvI-"};